import moment from 'moment';

export const getUTCOffset = () => moment().utcOffset() * 60000;
